import { COLORS } from 'helpers/globals'

const mapButton = {
  padding: '.25rem 1.25rem',
  display: 'flex',
  alignItems: 'center',
  '& img': {
    width: '5px',
    height: '20px',
    borderRadius: '6px',
    boxShadow: '0 1px 2px #00001E'
  }
}

export default {
  topBar: {
    display: 'flex',
    padding: '.5rem 1rem',
    flexShrink: 0,
    zIndex: 3,
    position: 'relative',
    background: 'white'
  },
  backLink: {
    flex: 1,
    color: 'black',
    fontWeight: '600'
  },
  backButton: {
    marginRight: '.5rem',
    fontSize: '1.4rem',
    verticalAlign: '-.1rem'
  },
  centerContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative'
  },
  logo: {
    height: '2rem',
    marginRight: '1rem'
  },
  saveIcon: {
    fontSize: '2rem',
    color: COLORS.primary,
    opacity: '0.5'
  },
  checkIcon: {
    fontSize: '1.2rem',
    color: '#009e25',
    position: 'absolute',
    bottom: '0.2rem',
    right: '-.5rem'
  },
  spinner: {
    fontSize: '1.2rem',
    color: COLORS.secondary,
    position: 'absolute',
    bottom: '0.2rem',
    right: '-.5rem'
  },
  rightContainer: {
    flex: 1,
    textAlign: 'right'
  },
  caretIcon: {
    marginLeft: '.5rem'
  },
  optionsMenu: {
    position: 'absolute',
    right: 0,
    top: '3.5rem',
    display: 'flex',
    flexDirection: 'column',
    background: 'white',
    color: COLORS.primary,
    fontWeight: '400',
    textAlign: 'left',
    border: `1px solid ${COLORS.quaternary}`,
    '& > div': {
      padding: '.75rem',
      borderBottom: `1px solid ${COLORS.quaternary}`,
      display: 'flex',
      alignItems: 'center',
      '&:nth-child(even)': {
        background: COLORS.tertiary
      },
      '&:last-of-type': {
        borderBottom: 0
      }
    }
  },
  icon: {
    marginRight: '.75rem',
    width: '2rem !important',
    fontSize: '1.8rem'
  },
  mapTypesContainer: {
    flexDirection: 'column',
    '& > span': {
      fontSize: '1.4rem',
      color: COLORS.secondary,
      marginBottom: '.25rem'
    }
  },
  mapButton,
  mapButtonCurrent: {
    ...mapButton,
    background: COLORS.primary,
    color: 'white',
    width: '100%'
  },
  blankView: {
    padding: '.25rem 1rem',
    marginRight: '7px',
    display: 'flex',
    borderRadius: '6px',
    width: '5px',
    height: '20px',
    backgroundColor: 'rgb(229, 227, 223)',
    boxShadow: '0 1px 2px #00001E',
    alignItems: 'center'
  }
}



// WEBPACK FOOTER //
// ./src/components/MobileTopBar/style.js